var map = {
	"./ico_facebook.svg": 5458,
	"./ico_instagram.svg": 9707,
	"./ico_peatix.svg": 3261,
	"./ico_twitter.svg": 9141,
	"./ico_youtube.svg": 7493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1713;